<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Family Company Statuses</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateFamilyCompanyStatus()">
        <mat-icon>add</mat-icon>
        Add Family Company Status
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="familyCompanyStatuses()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditFamilyCompanyStatus($event)"
      (deleteClick)="onDeleteFamilyCompanyStatus($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
